import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Globe2, PackageX } from "lucide-react";
import { BawainerCard } from "../components/cards";
import { Spinner, EmptyState } from "../components/common";
import RequestItemDialog from "../components/RequestItemDialog";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";

export default function WhosGoing() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [dests, setDests] = useState([]);
  const [active, setActive] = useState(params.get("dest") || "");
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reqTrip, setReqTrip] = useState(null);

  useEffect(() => { api.get("/destinations").then((r) => setDests(r.data)); }, []);

  useEffect(() => {
    if (!active) { setTrips([]); return; }
    setLoading(true);
    api.get(`/trips?destination=${active}`).then((r) => setTrips(r.data)).finally(() => setLoading(false));
  }, [active]);

  const activeDest = dests.find((d) => d.code === active);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading font-extrabold text-2xl text-navy flex items-center gap-2">
          <Globe2 className="text-sky" /> {t("nav_whosgoing")}
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Pilih destinasi untuk melihat siapa yang sedang berangkat.</p>
      </div>

      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
        {dests.map((d) => (
          <button key={d.code} onClick={() => { setActive(d.code); setParams({ dest: d.code }); }}
            data-testid={`wg-dest-${d.code}`}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold transition-colors flex items-center gap-1.5 ${
              active === d.code ? "bg-navy text-white" : "bg-white text-navy border border-black/5"}`}>
            <span>{d.flag}</span> {d.name}
            <span className={`text-xs ${active === d.code ? "text-lime" : "text-muted-foreground"}`}>{d.bawainer_count}</span>
          </button>
        ))}
      </div>

      {!active ? (
        <EmptyState icon={Globe2} title="Pilih destinasi" subtitle="Klik salah satu destinasi di atas untuk melihat BAWAINER yang berangkat ke sana." />
      ) : loading ? <Spinner /> : (
        <>
          <div className="bg-navy text-white rounded-3xl p-5">
            <div className="text-3xl">{activeDest?.flag}</div>
            <div className="font-heading font-extrabold text-xl mt-1">
              {trips.length} BAWAINER {trips.length === 1 ? "is" : "are"} going to {activeDest?.name}
            </div>
            <div className="text-white/60 text-sm">{t("going_this_month")}</div>
          </div>
          {trips.length === 0 ? (
            <EmptyState icon={PackageX} title={t("no_bawainer")} subtitle={`Belum ada yang berangkat ke ${activeDest?.name}.`} />
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {trips.map((tr) => (
                <BawainerCard key={tr.id} trip={tr} onRequest={user?.role === "titiper" ? setReqTrip : undefined} />
              ))}
            </div>
          )}
        </>
      )}
      {reqTrip && <RequestItemDialog trip={reqTrip} open={!!reqTrip} onOpenChange={(v) => !v && setReqTrip(null)} />}
    </div>
  );
}
